/**
 * Line-key helpers aligned with API `normalize_line_key` / `line_keys_match`
 * and `filter_disruptions_for_stop_lines` (exact match; empty affected_lines ⇒ show).
 */

export function normalizeLineName(value) {
  return String(value || '')
    .replace(/^(?:ligne|line)\s*/i, '')
    .trim()
    .toLowerCase();
}

/** Exact equality on normalized keys so `2` does not match `21`. */
export function lineNamesMatch(left, right) {
  const a = normalizeLineName(left);
  const b = normalizeLineName(right);
  if (!a || !b) return false;
  return a === b;
}

/**
 * Keep disruptions that affect at least one stop line.
 * Empty `affected_lines` stay visible (network-wide / unscoped).
 * When `stopLineNames` is empty (lineStyles not ready), skip client filtering.
 */
export function filterDisruptionsForStopLines(disruptions, stopLineNames) {
  const list = Array.isArray(disruptions) ? disruptions : [];
  const names = Array.isArray(stopLineNames) ? stopLineNames.filter(Boolean) : [];

  if (names.length === 0) {
    return list;
  }

  return list.filter((d) => {
    const affected = Array.isArray(d?.affected_lines) ? d.affected_lines : [];
    if (affected.length === 0) {
      return true;
    }
    return affected.some((line) =>
      names.some((stopLine) => lineNamesMatch(line, stopLine)),
    );
  });
}
